module.exports = __webpack_public_path__ + "img/no-data_chart-g.d886b6ef.svg";